import { Box, Card, InlineStack,Badge, Icon,Button } from '@shopify/polaris';
import {CheckIcon, ChevronDownIcon, ChevronUpIcon, MinusIcon,PlusIcon} from "@shopify/polaris-icons"
import React, { useState } from 'react';
import SwitchButton from './SwitchButton';

const FeatureList = ()=> {
  const shopify = window.shopify;
    const [differencesFeatures,setDifferencesFeatures] = useState(dataFeature)
    const handleSwitch = (value) => {
        if (value) {
          // 过滤数据：只保留isCommon为false的项
          const newContent = differencesFeatures.content.map(section => ({
            ...section,
            children: section.children.filter(child => !child.isCommon)
          }));
          setDifferencesFeatures({
            head: { ...differencesFeatures.head, showDifference: true },
            content: newContent
          });
        } else {
          // 恢复初始数据
          setDifferencesFeatures(dataFeature);
        }
      };
      const handleShowColl = (ind,k)=>{
        const newContent = differencesFeatures.content.map((section, sectionIndex) => {
          if (sectionIndex === ind) {
            const newChildren = section.children.map((child, childIndex) => {
              if (childIndex === k) {
                child.show = !child.show;
              }
              return child;
            });
            return {
                ...section,
                children: newChildren
            }
          }else {
            return section;
          }
        })
        setDifferencesFeatures({
          ...differencesFeatures,
          content: newContent
        });
      }
      const [isShowFeature,setIsShowFeature] = useState(false)
    return (
        <Box>
            <Box className={shopify ? "new_sub_plan_more new_sub_plan_more_shopify" : "new_sub_plan_more"}>
            <InlineStack align="center">
            <Button onClick={()=>setIsShowFeature(!isShowFeature)} icon={isShowFeature ? MinusIcon : PlusIcon}>Feature Comparison</Button>
            </InlineStack>
            </Box>
            {isShowFeature && <Box className="new_sub_differences_show" style={{maxHeight:isShowFeature ? '100%' :'0',opacity: isShowFeature ? 1 : 0,
    transition: 'max-height 0.3s ease, opacity 0.2s ease 0.1s'}}>
       <InlineStack blackAlign='center' wrap={false}>
            <Card padding={0}>
                <Box>
                    <Box className={shopify ? "difference_head difference_head_shopify" : "difference_head"}>
                        <InlineStack blackAlign='center' gap={300} wrap={false}>
                            <Box className="difference_show_btn">
                                <InlineStack gap={200}>
                                <SwitchButton open={differencesFeatures.head.showDifference} handleSwitch={handleSwitch}/>
                                    <span style={{fontSize:'14px',fontWeight:550,color:'rgba(48, 48, 48, 1)'}}>Only show differences</span>
                                </InlineStack>
                            </Box>
                            <Box className="difference_item">
                                <span className='difference_head_text'>Free</span>
                            </Box>
                            <Box className="difference_item">
                                <span className='difference_head_text'>Basic</span>
                            </Box>
                            <Box className="difference_item">
                                <span className='difference_head_text'>Pro</span>
                            </Box>
                            <Box className="difference_item">
                            <span className='difference_head_text'>Plus</span>
                            </Box>
                        </InlineStack>
                    </Box>
                    <Box className="difference_content">
                    {differencesFeatures.content.map((item,ind)=><Box key={ind}>
                        {item.children.length > 0 && <Box className="new_sub_differences_title">{item.title}</Box>}
                        {item.children.map((it,k)=><Box key={k} className="new_sub_differences_child">
                        <InlineStack  blackAlign='center' gap={300}  wrap={false}>
                            <Box className="difference_show_btn">
                                <InlineStack align='flex-start' blackAlign='center' gap={200}>
                                {(it.desc !== '' && it.show) ? <span onClick={()=>handleShowColl(ind,k)}><Icon source={it?.icon2} /></span> : <span onClick={()=>handleShowColl(ind,k)}><Icon source={it?.icon1} /></span>}
                                <span>{it.text1}</span>
                                </InlineStack>
                                {(it.desc !== '' && it.show) && <Box className="difference_show_dsc">{it.desc}</Box>}
                            </Box>
                            <Box className="difference_item"> 
                            {it.text2 !== '' && <span>{it.text2}</span>}
                            {it.textIcon1 !== '' && <Icon source={it.textIcon1} />}
                            </Box>
                            <Box className="difference_item">
                            {it.text3 !== '' && <span>{it.text3}</span>}
                            {it.textIcon2 !== '' && <Icon source={it.textIcon2} />}
                            </Box>
                            <Box className="difference_item">
                         {it.text4 !== '' && <span>{it.text4}</span>}
                         {it.textIcon3 !== '' && <Icon source={it.textIcon3} />}
                            </Box>
                            <Box className="difference_item">
                            {it.text5 !== '' && <span>{it.text5}</span>}
                            {it.textIcon4 !== '' && <Icon source={it.textIcon4} />}
                            </Box>
                        </InlineStack>
                        </Box>)}
                    </Box>)}
                    </Box>
                </Box>
            </Card>
            </InlineStack>
            </Box>}
        </Box>
    );
}
const dataFeature = {
    head:{
      showDifference:false,
    },
    content:[
      {
        title:'Find Products',
        children:[
          {
            text1:'Access to 1M+ Products',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:'',
            text4:'',
            text5:'',
            text6:'',
            isCommon:true,
          },
          {
            text1:'Access to Winning Products',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:'',
            text4:'',
            text5:'',
            text6:'',
            isCommon:false,
          },
          {
            text1:'Comprehensive Product Data',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:'',
            text4:'',
            text5:'',
            text6:'',
            isCommon:false,
          },
          {
            text1:'Dropshipman Product Imports',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:'',
            textIcon2:'',
            textIcon3:'',
            textIcon4:'',
            textIcon5:'',
            text2:'10 /month',
            text3:"300 /month",
            text4:"1000 /month",
            text5:"5000 /month",
            text6:"Unlimited",
            isCommon:false,
          },
          {
            text1:'AliExpress Product Imports',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:'',
            textIcon2:'',
            textIcon3:'',
            textIcon4:'',
            textIcon5:'',
            text2:'10 /month',
            text3:"300 /month",
            text4:"1000 /month",
            text5:"5000 /month",
            text6:"Unlimited",
            isCommon:false,
          },
          {
            text1:'Temu Product Imports',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:'',
            textIcon2:'',
            textIcon3:'',
            textIcon4:'',
            textIcon5:'',
            text2:'10 /month',
            text3:"300 /month",
            text4:"1000 /month",
            text5:"5000 /month",
            text6:"Unlimited",
            isCommon:false,
          },
          {
            text1:'Google Extension for Product Import',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Purchase Product Samples',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:true,
            desc:'Give 3rd party designers, developers, and marketing experts limited access to your store. (Does not count toward staff account limits.)',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'AI Product Selection',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:'',
            textIcon3:'',
            textIcon4:'',
            textIcon5:'',
            text2:'',
            text3:<Badge>Comming Soon</Badge>,
            text4:<Badge>Comming Soon</Badge>,
            text5:<Badge>Comming Soon</Badge>,
            text6:<Badge>Comming Soon</Badge>,
            isCommon:false,
          },
          {
            text1:'Social Media Product Ad Spy',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:'',
            textIcon5:'',
            text2:'',
            text3:"",
            text4:"",
            text5:<Badge>Comming Soon</Badge>,
            text6:<Badge>Comming Soon</Badge>,
            isCommon:false,
          },
        ]
      },
      {
        title:'Sourcing',
        children:[
          {
            text1:'Expert Sourcing Requests',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:'',
            textIcon3:'',
            textIcon4:'',
            textIcon5:'',
            text2:'',
            text3:"10/month",
            text4:"30/month",
            text5:"60/month",
            text6:"300/month",
            isCommon:false,
          },
          {
            text1:'Sourcing Timeframe',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:'',
            textIcon3:'',
            textIcon4:'',
            textIcon5:'',
            text2:'',
            text3:"1-5 days",
            text4:"1-5 days",
            text5:"1-3 days",
            text6:"1-2 days",
            isCommon:false,
          },
          {
            text1:'Bulk Product Sourcing',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:false,
          },
          {
            text1:'Priority Sourcing Processing',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:false,
          },
          {
            text1:'Automated Order Product Sourcing',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:false,
          },
        ]
      },
      {
        title:'Products Management',
        children:[
          {
            text1:'Complete Products Listing',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Bulk Edit Collections',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Bulk Edit Tags',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Bulk Edit Product Types',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Bulk Product Listing',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:false,
          },
          {
            text1:'AI Title Optimization',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:false,
          },
          {
            text1:'AI Description Optimization',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:false,
          },
          {
            text1:'Basic Product Pricing Rules',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Advanced Product Pricing Rules',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:false,
          },
          {
            text1:'Restore Deleted Products',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
        ]
      },
      {
        title:'Order Payment',
        children:[
          {
            text1:'Automatic Payment',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:false,
          },
          {
            text1:'Bulk Payment',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'PayPal Payment',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Payoneer Payment',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Payment via Credits',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Coupon Applied to Total Order Amount',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Points Redeemed for Order Amount',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
        ]
      },
      {
        title:'Order Fulfillment',
        children:[
          {
            text1:'Auto Sync Store Orders',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Automated Fulfillmentt',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:false,
          },
          {
            text1:'Auto Order Issues Alert',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Auto Order Status Notification',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Shipping Methods',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:'',
            textIcon2:'',
            textIcon3:'',
            textIcon4:'',
            textIcon5:'',
            text2:'Basic',
            text3:"Basic",
            text4:"Basic",
            text5:"VIP",
            text6:"VIP",
            isCommon:false,
          },
          {
            text1:'Product Quality Inspection',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:'',
            textIcon2:'',
            textIcon3:'',
            textIcon4:'',
            textIcon5:'',
            text2:'Basic',
            text3:"Basic",
            text4:"Adanced",
            text5:"Adanced",
            text6:"Rigorous",
            isCommon:false,
          },
          {
            text1:'Automatic Tracking Number Update',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Full Order Tracking',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Bulk Order Tracking Management',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:false,
          },
          {
            text1:'Download Order Invoice',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
        ]
      },
      {
        title:'Custom Services',
        children:[
          {
            text1:'Custom Private Storage Solutions',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:MinusIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Custom Brand Packaging & Cards',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:MinusIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Personalized Trending Product Suggestions',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:MinusIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Recommended Chinese Factories & Sources',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:MinusIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Optimal Logistics Route Suggestions',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:MinusIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Custom Product Photography',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:MinusIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
        ]
      },
      {
        title:'Integrations',
        children:[
          {
            text1:'Pagefly',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Gempages',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'SeoAnt',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Parcel Panel',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'TrackingMore',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Trustoo',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Paypal',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Payoneer',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
        ]
      },
      {
        title:'Support',
        children:[
          {
            text1:'24/7 Online Customer Support',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:'',
            textIcon4:"",
            textIcon5:"",
            text2:'',
            text3:"",
            text4:"VIP",
            text5:"VIP",
            text6:"Super VIP",
            isCommon:false,
          },
          {
            text1:'Dedicated Account Manager',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:false,
          },
          {
            text1:'Personal Support Agent',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:MinusIcon,
            textIcon3:MinusIcon,
            textIcon4:MinusIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'New User Onboarding Guide Video',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Discord Community',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:CheckIcon,
            textIcon2:CheckIcon,
            textIcon3:CheckIcon,
            textIcon4:CheckIcon,
            textIcon5:CheckIcon,
            text2:'',
            text3:"",
            text4:"",
            text5:"",
            text6:"",
            isCommon:true,
          },
          {
            text1:'Dropshipping Academy',
            icon1:ChevronDownIcon,
            icon2:ChevronUpIcon,
            show:false,
            desc:'',
            textIcon1:MinusIcon,
            textIcon2:'',
            textIcon3:'',
            textIcon4:'',
            textIcon5:'',
            text2:'',
            text3:<Badge>Comming Soon</Badge>,
            text4:<Badge>Comming Soon</Badge>,
            text5:<Badge>Comming Soon</Badge>,
            text6:<Badge>Comming Soon</Badge>,
            isCommon:false,
          },
        ]
      },
    ]
  }
export default FeatureList;
